module.exports = __webpack_public_path__ + "img/il.15668e72.svg";